import * as React from 'react';

import { CatalogCategoryMenu } from 'components/catalogs/components/CatalogCategoryMenu/CatalogCategoryMenu';
import { CatalogCategoryProductsSections } from 'components/catalogs/components/CatalogCategoryProductsSections/CatalogCategoryProductsSections';
import { CatalogFirstView } from 'components/catalogs/components/CatalogFirstView/CatalogFirstView';
import { CatalogUsageNotes } from 'components/catalogs/components/CatalogUsageNotes/CatalogUsageNotes';
import { CatalogLayout } from 'components/catalogs/layouts/CatalogLayout/CatalogLayout';
import { readCatalogPayload } from 'components/catalogs/libs/readCatalogPayload';

const CatalogViewPage = (): JSX.Element => {
  const payload = readCatalogPayload();
  const catalogCode = String(payload.params?.catalogCode ?? '');

  return (
    <CatalogLayout
      data-page="catalogs-view"
      catalogCode={catalogCode}
    >
      <CatalogFirstView />
      <CatalogUsageNotes />
      <CatalogCategoryMenu />
      <CatalogCategoryProductsSections />
    </CatalogLayout>
  );
};

export default CatalogViewPage;
